export const buildInfo = {
  version: '0.50.1',
  lastCommitDate: new Date(1598972006000),
  buildDate: new Date(1598974088225)
};
